module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.topic.editMode),
      expression: "!topic.editMode"
    }]
  }, [_vm._v("创建专题")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topic.editMode),
      expression: "topic.editMode"
    }]
  }, [_vm._v("编辑专题")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.topic,
      "callback": _vm.save
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("标题")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.name),
      expression: "topic.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.topic.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topic, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("简介")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.description),
      expression: "topic.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "placeholder": "此处填写专题简介……"
    },
    domProps: {
      "value": (_vm.topic.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topic, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("专题主题样式")]), _vm._v(" "), _c('ThemePagerSelection', {
    attrs: {
      "activeTheme": _vm.topic.theme
    }
  })], 1), _vm._v(" "), _c('NbExpanding', [(_vm.topic.theme && _vm.topic.theme.editComponent) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("专题样式附加属性修改")]), _vm._v(" "), _c('div', {
    staticClass: "mt5"
  }, [_c(_vm.topic.theme.editComponent, {
    ref: "themeEditComponent",
    tag: "component",
    model: {
      value: (_vm.topic.remark),
      callback: function($$v) {
        _vm.$set(_vm.topic, "remark", $$v)
      },
      expression: "topic.remark"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("专题首页样式类型")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.type),
      expression: "topic.type"
    }],
    staticClass: "form-control m-b",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.topic, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.topic.TypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("访问地址(只能包含英文，数字以及“-”和“_”)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.location),
      expression: "topic.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.topic.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topic, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("封面")]), _vm._v(" "), (_vm.topic.theme && _vm.topic.theme.logoRemark) ? _c('span', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.topic.theme.logoRemark))]) : _vm._e(), _vm._v(" "), _c('div', [_c('NbTank', {
    attrs: {
      "tank": _vm.topic.poster
    }
  })], 1)]), _vm._v(" "), (_vm.topic.type === 'ARTICLE') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("首页文章")]), _vm._v(" "), _c('ArticlePagerSelection', {
    attrs: {
      "activeArticle": _vm.topic.article
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topic.type === 'SCENERY') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("定制页面")]), _vm._v(" "), _c('SceneryPagerSelection', {
    attrs: {
      "activeScenery": _vm.topic.scenery
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("菜单结构")]), _vm._v(" "), _c('TopicMenuFrame', {
    attrs: {
      "topic": _vm.topic
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topic.errorMessage),
      expression: "topic.errorMessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.topic.errorMessage) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.topic,
      "callback": _vm.save
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-49f12fcb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/topic/Create.vue
// module id = 977
// module chunks = 1